export default "__VITE_ASSET__b78fa6b0__"